module.exports = __webpack_public_path__ + "static/af-iverted-logo.7ac84315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/af-iverted-logo.svg
// module id = 1405
// module chunks = 35783957827783